import { combineReducers } from "@reduxjs/toolkit";

import globalReducer from "./globalReducer";
import authReducer from "./authReducer";
import fleetReducer from "./fleetReducer";
import bookingReducer from "./bookingReducer";
import globalDataReducer from "./GlobalData";

const mainReducer = combineReducers({
  global: globalReducer,
  auth: authReducer,
  fleet: fleetReducer,
  book: bookingReducer,
  globalData: globalDataReducer,
});

export default mainReducer
